import { createContext, useContext } from 'react';
import { MediaEvent } from './media.events';
import { MediaState } from './domain/media-file.types';
import { useMediaPreviewer } from './hooks';

export type MediaContextValue = {
  readonly files: MediaState;
  dispatch: (event: MediaEvent) => MediaState;
  previewer: ReturnType<typeof useMediaPreviewer>;
};

export const MediaContext = createContext<MediaContextValue | null>(null);

export const useMedia = (): MediaContextValue => {
  const ctx = useContext(MediaContext);

  if (!ctx) {
    throw new Error('Media компоненты должны быть внутри <Media.Root>');
  }

  return ctx;
};
